import React, { useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';
import LightImg from '../../../assets/img/illustrations/auth-basic-forgot-password-mask-light.png';
import DarkImg from '../../../assets/img/illustrations/auth-basic-forgot-password-mask-dark.png';
import './index.scss';

const ForgotPasswordIllustrations: React.FC = () => {
  const { theme } = useContext(AuthContext);
  const imgSrc = theme === 'dark' ? DarkImg : LightImg;

  return (
    <img 
      src={imgSrc} 
      alt="Forgot password illustration" 
      className="auth-illustration"
    />
  );
};

export default ForgotPasswordIllustrations;
